import styled from 'styled-components';
import { rem } from 'polished';

const ConversionRowContainer = styled.div`
    margin-top: ${rem(8)};
`;

export default ConversionRowContainer;
